import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { authSlice } from "./slices/Auth";
import storage from "redux-persist/lib/storage";

import userSlice from "./userSlice/index";
import organizationSlice from "./organizationSlice/index";
import pricingSlice from "./pricingSlice/index";

import {
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";


const persistConfig = {
  key: "internal",
  storage,
};

const reducers = combineReducers({
  auth: authSlice.reducer,
  userData: userSlice,
  organizationData:organizationSlice,
  pricingData:pricingSlice
});

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
      immutableCheck: false,
    }),
});
